module.exports = __webpack_public_path__ + "static/fipcbrownsafari4-e427cac4e97236650a0c99cd35012aa0.jpeg";